import { useAppSelector } from 'app/hooks';

type TextKeyProps = Readonly<{
  code: string;
  fallback?: string;
}>;

export default function TextKey({ code, fallback }: TextKeyProps) {
  const value = useAppSelector((state) => state.data.textKeys[code]);
  const developerMode = useAppSelector((state) => state.ui.developerMode);
  const resolved = value ?? fallback ?? code;

  if (developerMode) {
    return (
      <span className='group relative cursor-help'>
        {resolved}
        <span className='pointer-events-none absolute bottom-full left-1/2 z-50 mb-1 hidden -translate-x-1/2 whitespace-nowrap rounded bg-gray-900 px-2 py-1 font-mono text-xs text-white shadow-lg group-hover:block'>
          {code}
        </span>
      </span>
    );
  }

  return resolved;
}
